import API from '../api/Api';

/**
 * return the messages that needs to be displayed to the agent
 * @param {*} state 
 */
export const getMessages = (state) => state[API.messages._key];